<button
  #trigger
  type="button"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [style.display]="hideTrigger ? 'none' : null"
  [class]="label ? 'ss-btn secondary' : 'ss-btn-icon ss-btn-icon--more'"
  [disabled]="disabled || !items.length"
  [attr.aria-label]="label ? null : title"
  aria-haspopup="menu"
  [attr.aria-expanded]="opened"
  (click)="toggle()"
  (keydown.arrowdown)="$event.preventDefault(); opened || toggle()">
  <lucide-icon [name]="icon" aria-hidden="true"></lucide-icon>{{ label }}
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="anchor || origin"
  [cdkConnectedOverlayOpen]="opened"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close(false)"
  (detach)="opened = false"
  (attach)="focusFirst()">
  <div #panel class="ss-action-menu__panel" role="menu" [attr.aria-label]="title" (keydown)="keydown($event)">
    <ng-container *ngFor="let item of items">
      <div *ngIf="item.separator" class="ss-action-menu__separator" role="separator"></div>
      <button
        type="button"
        role="menuitem"
        [class.ss-action-menu__item--danger]="tone(item) === 'danger'"
        [disabled]="item.disabled"
        (click)="select(item)">
        <span class="ss-action-menu__icon ss-action-menu__icon--{{ tone(item) }}">
          <lucide-icon [name]="item.icon || definition(item).icon" [size]="15" aria-hidden="true"></lucide-icon>
        </span>
        {{ item.label }}
      </button>
    </ng-container>
  </div>
</ng-template>
